(ns app.front.view.occupancy.list
  (:require [app.domain.party.model :as party-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.util :refer [for-frag] :as futil]
            [app.front.view.occupancy.edit :as occupancy-edit]
            [app.front.view.system-of-units.toggle :as sou-toggle]
            [app.front.view.workspace.primary-actions :as primary-actions]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))



(rf/reg-event-db
  ::edit-app
  (fn [db [_ app-id]]
    (let [app (-> db (get-in [::entities/entity-db app-id]))]
      (assoc-in db [::occupancy-edit/edit-occupancy-application app-id]
                {:expected-date-of-occupancy (:partial-occupancy/expected-date-of-occupancy app)
                 :description-of-request     (:partial-occupancy/description-of-request app)
                 :area-to-be-occupied        (:partial-occupancy/area-to-be-occupied app)}))))


(rf/reg-sub ::get-edit-application-value
  (fn [db [_ attr ws-id]]
    (-> db ::occupancy-edit/edit-occupancy-application (get ws-id) attr)))


(rf/reg-event-db
  ::close-edit
  (fn [db [_ app-id]]
    (update db ::occupancy-edit/edit-occupancy-application dissoc app-id)))


(rf/reg-sub ::edit?
  (fn [db [_ app-id]]
    (-> db ::occupancy-edit/edit-occupancy-application (get app-id))))


(rf/reg-sub ::partial-occupancy-apps
  :<- [::ws-subs/execution]
  (fn [execution _]
    (->> execution
         :entity/_parent
         (filter (partial eu/is-type? :entity.type/partial-occupancy))
         (sort-by :entity/created))))


(defn expected-date-of-occupancy [{:keys [tr app edit? ws-id]}]
  [:div.mt-3.mr-4
   [:span.font-light.mr-2 (tr [:occupancy/expected-date-of-occupancy])]
   [:span.font-bold
    (if edit?
      [occupancy-edit/date-of-occupancy-input
       (util/mmap {:class-name "my-2"
                   :value      (<sub [::get-edit-application-value :expected-date-of-occupancy (:db/id app)])
                   :app-id     (:db/id app)
                   :edit?      true}
                  tr ws-id)]
      ((<sub [::date-util/date-fn]) (:partial-occupancy/expected-date-of-occupancy app)))]])


(defn area-to-be-occupied [{:keys [tr app edit? ws-id]}]
  [:div.mt-3.mr-4
   [:span.font-light.mr-2 (tr [:occupancy/area-to-be-occupied])]
   [:span.font-bold
    (if edit?
      [occupancy-edit/area-to-be-occupied-input
       (util/mmap {:value  (<sub [::get-edit-application-value :area-to-be-occupied (:db/id app)])
                   :app-id (:db/id app)
                   :edit?  true}
                  tr ws-id)]
      (str (<sub [::sou-toggle/value-in-selected-system :m2 (:partial-occupancy/area-to-be-occupied app)]) " "
           (<sub [::sou-toggle/label-in-selected-system :m2])))]])


(defn description-of-request [{:keys [tr app edit? ws-id]}]
  [:div.h-500.mb-6
   [:div.flex.mt-8
    [:span.font-light (tr [:occupancy/description-of-request])]]
   (if edit?
     [occupancy-edit/description-of-request
      (util/mmap {:value  (<sub [::get-edit-application-value :description-of-request (:db/id app)])
                  :app-id (:db/id app)
                  :edit?  true}
                 ws-id)]
     [:div.flex
      [:span (ui/text-to-paragraphs (-> app :partial-occupancy/description-of-request) "mt-4")]])])


(defn send-finalize-signal [{:keys [execution app]} end-state comments]
  (>evt [:app.front.process/signal
         execution
         [:process.signal/finalize-partial-occupancy (cond-> {:app-id       (:db/id app)
                                                              :domain/state end-state}

                                                       (not (str/blank? comments))
                                                       (assoc :partial-occupancy/authority-comments comments))]]))


(def finalize-button-opts [[:occupancy/decline-partial-occupancy-title
                            :occupancy/decline-partial-occupancy-button
                            :partial-occupancy.state/declined
                            :tertiary]
                           [:occupancy/approve-partial-occupancy-title
                            :occupancy/approve-partial-occupancy-button
                            :partial-occupancy.state/approved
                            :primary]])


(defn finalize-buttons [{:keys [tr] :as props}]
  (r/with-let [*comments (r/atom nil)]
    [:div.w-full.flex.flex-wrap.justify-end
     (for-frag [[title-i18n button-i18n end-state button-kind] finalize-button-opts]
       [ui/modal-confirmation-button {:tr                  tr
                                      :modal-title         (tr [title-i18n])
                                      :trigger-button-opts {:kind       button-kind
                                                            :size       :small
                                                            :class-name "p-1 mr-2"}
                                      :trigger-button-text (tr [button-i18n])
                                      :on-yes-click        #(send-finalize-signal props end-state @*comments)}
        [ui/text-area {:label-text (tr [:approval/comments])
                       :value      @*comments
                       :on-change  #(reset! *comments (futil/tval %))}]])]))


(defn- render-application [{:keys [lang tr execution]}
                           {:partial-occupancy/keys [submitted-by applicant authority-comments
                                                     finalized-ts finalized-by]                :as app}]
  (let [app-id       (:db/id app)
        edit?        (<sub [::edit? app-id])
        state        (:domain/state app)
        can-edit?    (<sub [:app.front.process/execution-signal-permitted?
                            [:process.signal/edit-partial-occupancy {:app-id app-id}]])
        can-approve? (<sub [:app.front.process/execution-signal-permitted?
                            [:process.signal/finalize-partial-occupancy {:app-id app-id}]])
        ws-id        (<sub [::ws-subs/workspace-id])]
    [:div.pb-2.mb-4.bg-gray-100.border.border-4
     [:div.p-2.flex.mb-2.bg-gray-200.items-center.justify-between
      [:span.font-bold.mr-4.p-2 (tr [:occupancy/partial-occupancy-application])]
      [:span.uppercase.p-2
       (when (and can-edit?
                  ; FIXME: Should be guards
                  (some #{:partial-occupancy.state/applied
                          :partial-occupancy.state/in-process} #{state}))
         (cc/button {:kind             :ghost
                     :size             :small
                     :icon             (if edit? i/remove i/pen)
                     :icon-description ""
                     :class-name       "p-1 mr-2"
                     :on-click         #(>evt [(if edit? ::close-edit ::edit-app) app-id])}
                    (tr [(if edit? :close :edit)])))
       (tr [(keyword (:domain/state app))])]]
     [:div.px-4.pb-4.pt-2
      [:div.flex.flex-1.w-full.flex-wrap.mb-2
       [expected-date-of-occupancy (util/mmap tr app edit? ws-id)]
       [area-to-be-occupied (util/mmap tr app edit? ws-id)]
       [:div.mt-3.mr-4
        [:span.font-light.mr-2 (tr [:occupancy/application-date])]
        [:span.font-bold.mr-2 ((<sub [::date-util/date-fn]) (:entity/created app))]
        [:span (when submitted-by
                 (if (= (-> applicant :party/user :db/id) (:db/id submitted-by))
                   (tr [:occupancy/submitted-by]
                       [(-> submitted-by user-model/full-name)])
                   (tr [:occupancy/submitted-on-behalf]
                       [(-> submitted-by user-model/full-name)
                        (-> applicant (party-model/corporation-and-full-name-or-full-name lang))])))]]]
      [description-of-request (util/mmap tr app edit? ws-id)]
      [:div
       (cond
         can-approve?
         [finalize-buttons (util/mmap tr app execution)]

         (= (:domain/state app) :partial-occupancy.state/applied)
         [:div.flex.w-full.justify-end.text-support-01 (tr [:occupancy/in-process-footer])]

         (#{:partial-occupancy.state/approved :partial-occupancy.state/declined} (:domain/state app))
         [:div.flex.flex-1.w-full.flex-wrap.items-end
          [:div.w-full.lg:w-1-2
           (when authority-comments
             [:<>
              [:div.font-light (tr [:occupancy/authority-comments])]
              [:div (ui/text-to-paragraphs authority-comments "mt-4")]])]
          [:div.font-bold.flex.w-full.lg:w-1-2.mt-3.lg:mt-0.justify-end
           (tr [:occupancy/result-on-by]
               [(tr [(:domain/state app)])
                ((<sub [::date-util/date-time-fn]) finalized-ts)
                (user-model/full-name finalized-by)])]])]]]))


(defn view
  "Render all partial occupancy applications"
  [{:keys [tr] :as props} apps apply-permitted?]
  (let [execution (<sub [::ws-subs/execution])]
    [:<>
     (for-frag [app apps]
       ^{:key (:db/id app)}
       [render-application (assoc props :execution execution) app])
     (when apply-permitted?
       (cc/button {:kind             :primary
                   :icon             i/plus
                   :icon-description ""
                   ;; kind of a hacky way of calling a function that opens up a dialog by an fsm action
                   ;; since the apply button needed to be in the section also
                   :on-click         #(primary-actions/handle-action {:signal-id      :process.signal/apply-partial-occupancy
                                                                      :signal-type    :select
                                                                      :confirm?       true
                                                                      :process-target execution})}
                  (tr [:process.signal/apply-partial-occupancy])))]))
